export default "__VITE_ASSET__BPxqQpC$__"